








import { computed, defineComponent } from '@vue/composition-api';
import HtmlModal from '@/components/UI/HtmlModal.vue';
import { useStore } from '@/store';
import { MutationTypes } from '@/store/mutations';

export default defineComponent({
    name: 'IncludedOptionsModal',
    components: { HtmlModal },
    setup () {
        const store = useStore();
        const html = computed(() => store.getters.getIncludedOptions);
        const isOpened = computed(() => store.state.includedOptionsModal.isOpened);
        const close = () => {
            store.commit(MutationTypes.CloseIncludedOptionsModal);
        };
        return { isOpened, close, html };
    }
});
